export { TenderReportComponent } from './tender-report.component';
